import { render, staticRenderFns } from "./SendCodeButton.vue?vue&type=template&id=28956cf4&scoped=true&"
import script from "./SendCodeButton.vue?vue&type=script&lang=js&"
export * from "./SendCodeButton.vue?vue&type=script&lang=js&"
import style0 from "./SendCodeButton.vue?vue&type=style&index=0&id=28956cf4&prod&lang=scss&scoped=true&"
import style1 from "./SendCodeButton.vue?vue&type=style&index=1&id=28956cf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28956cf4",
  null
  
)

export default component.exports